import React from 'react'
import ProfilePage from './Profile'

const Profile = () => (
  <ProfilePage />
)

export default Profile